import { makeStyles } from '@material-ui/core/styles';
export default makeStyles(theme => ({
  pageWrapper: {
    height: '100vh',
    display: 'flex',
    flexDirection: 'column'
  },
  pageContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flexGrow: '1'
  },
  boxWrapper: {
    padding: theme.spacing(3)
  },
  textWelcome: {
    // ...theme.custom.fontFamily.metropolis
  },
  textRegister: {
  },
  textRegisterText: {
    // ...theme.custom.fontFamily.metropolis,
  },
  textNotice: {
    // ...theme.custom.fontFamily.roboto,
  },
  textAttribution: {
  },
  textCreator: {
  },
  loginButtonRoot: {
  },
  loginButtonText: {
  },
  logo: {
  },
  inputRoot: {
  },
  inputNotchedOutline: {},
  inputFocused: {},
  inputLabelRoot: {
  }
}));



// WEBPACK FOOTER //
// ./src/pages/LoginPage/styles.js